import mediaQuery from 'css-mediaquery';
import { API_V1_HOSTNAME_KEY, API_V4_HOSTNAME_KEY } from '../localStorageKeys';

export const slugify = (string: string) =>
  string
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

export const initials = (name: string) =>
  name
    ?.match(/(^\S?|\s\S)?/g)
    ?.map((v) => v.trim())
    .join('')
    .match(/(^\S|\S$)?/g)
    ?.join('')
    .toLocaleUpperCase();

export const createMatchMedia = (width) => (query) => ({
  matches: mediaQuery.match(query, {
    width,
  }),
  addEventListener: jest.fn(),
  removeEventListener: jest.fn(),

  media: query,
  onchange: null,
  addListener: jest.fn(),
  removeListener: jest.fn(),
  dispatchEvent: jest.fn(),
});

export const formatDates = (date: Date, date2: Date) => {
  const formattedDate1 = new Date(date.toDateString());
  const formattedDate2 = new Date(date2.toDateString());
  formattedDate1.setUTCHours(0, 0, 0, 0);
  formattedDate2.setUTCHours(0, 0, 0, 0);
  return [formattedDate1.getTime(), formattedDate2.getTime()];
};

export const dateTodayOrAfter = (dates: number[]) => dates[0] >= dates[1];
export const datesAreTheSame = (dates: number[]) => dates[0] === dates[1];

export const sessionHasBeenCleared = (url: string): boolean => {
  const apiLocalStorageKeys = [
    API_V1_HOSTNAME_KEY,
    API_V4_HOSTNAME_KEY,
  ];

  const hostnameErasedFromLocalStorage = apiLocalStorageKeys.reduce((result: boolean, key: string) => result || (localStorage.getItem(key) === null), false);

  return url.startsWith("null") && hostnameErasedFromLocalStorage;
}

export const checkChildLinkActive = (locationPath: string, paths: string[]) =>
  paths.find((path) => locationPath.includes(path)) != null;

export const getBaseDomain = (domain: string) => {
  const split = new URL(domain).hostname.split(".");
  return split.length <= 2 ? split.join(".") : split.slice(1).join(".")
}
